import { Pipe, PipeTransform } from '@angular/core';
import { VariableSummary } from '@mtna/variable-service-core-ts';

import { BaseFilter } from '../core/models/filter/index';

@Pipe({
  name: 'rdsGetFilterValue',
})
export class RdsGetFilterValuePipe implements PipeTransform {
  transform(
    count: number,
    filters: Array<BaseFilter<VariableSummary>>,
    multiVariableSelect: boolean
  ): VariableSummary | Array<VariableSummary> | null {
    if (count === 0) {
      return multiVariableSelect ? [] : null;
    }

    return multiVariableSelect ? filters.filter((f) => !!f.variable).map((f) => f.variable) : filters[0].variable;
  }
}
